package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.LockpickingRepository

/**
 * Use case for cancelling a lockpicking challenge (GM action).
 */
class CancelLockpickingUseCase(
    private val lockpickingRepository: LockpickingRepository
) {
    suspend operator fun invoke(
        lockpickingId: String
    ): Result<Unit> {
        return lockpickingRepository.cancel(
            lockpickingId = lockpickingId
        )
    }
}
